<div class="wrap padding-md">
  <div *ngIf="product$ | async as product" class="content border-md">
    <div class="top">
      <div *ngIf="product.photos?.length! > 0" class="img">
        <swiper-container
          class="photos-swiper"
          navigation="true"
          slides-per-view="1"
          loop="false"
          edge-swipe-detection="true"
          speed="100"
          long-swipes="true"
          long-swipes-ratio="0.3"
          #productListSwiper
        >
          <swiper-slide
            class="swiper-slide"
            *ngFor="let photoUrl of product.photos"
          >
            <div
              [appBackgroundImage]="photoUrl | productImage | async"
              class="img"
              [class.no-image]="product.photos.length < 1"
            ></div>
          </swiper-slide>
        </swiper-container>
      </div>
      <div class="details padding-md">
        <div class="header">
          <div class="product-name">{{ product.name }}</div>
        </div>
        <hr class="mb-md" />
        <div class="price-and-quantity">
          <div class="price">
            <app-price-label
              [value]="product | getRelevantProductPrice | appCurrency | async"
              [secondaryCurrencyAlight]="'start'"
            ></app-price-label>
          </div>
          <ng-container *ngIf="quantityInCart$ | async as quantity">
            <div *ngIf="quantity > 0" class="quantity">
              <app-quantity-selector
                [min]="0"
                [max]="99"
                [value]="quantity"
                (valueDecreased)="decreaseQuantity($event)"
                (valueIncreased)="increaseQuantity($event)"
              ></app-quantity-selector>
            </div>
          </ng-container>
        </div>
        <hr class="mb-sm" />

        <ng-container *ngIf="orderType === orderTypes.DELIVERY">
          <div class="delivery-time">
            <app-svg-icon class="icon" name="motobiker"></app-svg-icon>
            <div class="text">
              {{
                selectedDay!
                  | deliveryTime : (clientLocation$ | async)?.workTime
              }}
            </div>
          </div>
          <hr class="mb-md" />
        </ng-container>

        <div class="description">
          <div class="title mb-sm">
            {{ "@pages.productDetails.descriptionTitle" | translate }}
          </div>
          <div (click)="onDescriptionInfoClick()" class="info-icon">
            <app-svg-icon name="info"></app-svg-icon>
          </div>
        </div>
        <div class="description-text mb">
          {{ product.description }}
        </div>
      </div>
    </div>
    <div
      *ngIf="(quantityInCart$ | async) !== null && isOpenedAfterScanningBarcode"
      class="bottom"
    >
      <app-action-button
        *ngIf="(quantityInCart$ | async) === 0"
        (click)="addToCart()"
        [label]="'@pages.productDetails.actionBtn.addToCart' | translate"
        [disabled]="isProductUnavailable"
      ></app-action-button>
      <app-action-button
        *ngIf="(quantityInCart$ | async)! > 0"
        [isOutlined]="true"
        [label]="'@pages.productDetails.actionBtn.added' | translate"
      ></app-action-button>
    </div>
  </div>
  <div class="app-spinner-container">
    <ion-spinner
      *ngIf="(product$ | async) === null"
      class="app-spinner"
    ></ion-spinner>
  </div>
</div>
